/** Returns the raw initData string for the Authorization header. */
export function getInitData(): string {
  // Production: real Telegram WebApp.
  const tg = (window as any).Telegram?.WebApp;
  if (tg?.initData) return tg.initData;
  // Dev outside Telegram: fall back to a signed initData baked at build time
  // by `make miniapp-init-data` (writes miniapp/.env.local).
  const dev = import.meta.env.VITE_DEV_INIT_DATA;
  if (dev) return dev;
  throw new Error(
    'No initData. Open inside Telegram, or run `make miniapp-init-data` and rebuild.',
  );
}
